import { TelemetryOptions } from "./TelemetryOptions";

export function getDefaultTelemetryOptions(): TelemetryOptions {
    return {
        reportErrors: true
    };
}
